export default (index) => ({
    index,
    state: false,
    trigger() {
        this.$dispatch(this.state ? 'close' : 'open', this.index)
    },
});